import React, { useState, useEffect } from 'react';
import { Grid, Typography, Box } from '@mui/material';
import WorkExperienceRecord, { WorkExperience } from './WorkExperienceRecord';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import IconButton from '@mui/material/IconButton';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';

const initialState: WorkExperience[] = [
  {
    id: null,
    title: 'SDE',
    company: 'Amazon',
    location: 'BC',
    startDate: null,
    endDate: null,
  },
];
interface WorkExperienceSectionProp {
  viewMode?: boolean;
  data: WorkExperience[];
}

const WorkExperienceSection: React.FC<WorkExperienceSectionProp> = ({
  viewMode = false,
  data,
}) => {
  const [workExpState, setWorkExpState] =
    useState<WorkExperience[]>(initialState);
  // TODO get id: 1. hr_mode: from url 2. applicant_mode: from redux store
  useEffect(() => {
    setWorkExpState(data);
  }, [data]);

  const addButtonHandler = () => {
    const newRecord: WorkExperience = {
      id: null,
      title: '',
      company: '',
      location: '',
      startDate: null,
      endDate: null,
    };
    setWorkExpState(state => [...state, newRecord]);
  };

  const deleteWorkExpRecord = (idx: number) => {
    setWorkExpState(state => {
      return state.filter((record, i) => idx !== i);
    });
  };

  const workExpRecords = workExpState.map((record, i) => {
    return (
      <WorkExperienceRecord
        key={i}
        idx={i}
        data={record}
        deleteRecord={deleteWorkExpRecord}
        viewMode={viewMode}
      />
    );
  });
  return (
    <Grid item xs={12} md={12} sx={{ mt: '60px' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '2vh' }}>
        <WorkOutlineIcon sx={{ color: 'var(--ttg-green)', marginRight: '1rem', fontSize: '2.5rem' }} />
        <Typography
          variant="h4"
          sx={{
            color: 'var(--ttg-black)',
            fontFamily: 'inherit',
            textAlign: 'left',
            fontWeight: 600,
            textTransform: 'uppercase',
            letterSpacing: '0.1rem',
            fontSize: { xs: '1.5rem', sm: '2.125rem' },
          }}
        >
          Work Experience
        </Typography>
      </Box>
      {workExpRecords}
      {viewMode ? null : (
        <Grid item xs={12} md={12}>
          <IconButton
            size="large"
            aria-label="account of current user"
            aria-controls="menu-appbar"
            aria-haspopup="true"
            onClick={addButtonHandler}
            color="inherit"
            sx={{ marginTop: '3vh' }}
          >
            <AddCircleIcon sx={{ color: 'var(--ttg-black)' }} />
          </IconButton>
        </Grid>
      )}
    </Grid>
  );
};

export default WorkExperienceSection;
